import { httpGet } from "../../services/api";
import { convertKeysToCamelCase } from "../utils/convertKeysToCamelCase";

export const sdkGetLoyaltyProviders = async ({
  publicApiKey,
}: {
  publicApiKey: string;
}) => {
  const response = await httpGet<{
    data: {
      loyalty_providers: LoyaltyProvider[];
    };
  }>(`loyalty/providers/`, undefined, undefined, {
    "x-public-key": publicApiKey,
  });

  const { loyalty_providers } = response.data;
  return loyalty_providers.map((provider) => convertKeysToCamelCase(provider));
};
